import jsona from '@/lib/jsona';
import VisnetModemLogEvents from '@/resources/visnet-hub-modem-log-events';
import PaginatedList from './mixins/paginated-list';

const DEFAULT_STATE = {
  modemLogEvents: {},
  error: ''
};

export default {
  namespaced: true,
  ...PaginatedList(VisnetModemLogEvents, {
    state: DEFAULT_STATE,
    /* eslint no-param-reassign: ["error", { "props": false }] */
    mutations: {
      setModemEventsLogData(state, response) {
        state.modemData = jsona.deserialize(response);
      },
      setError(state, newError) {
        state.error = newError;
      },
      resetStore(state) {
        Object.assign(state, DEFAULT_STATE);
      }
    },
    getters: {
      modemLogEvents: state => state
    }
  })
};
